import { render, staticRenderFns } from "./PracticeEvaluate.vue?vue&type=template&id=34bdd140&scoped=true&"
import script from "./PracticeEvaluate.vue?vue&type=script&lang=js&"
export * from "./PracticeEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./PracticeEvaluate.vue?vue&type=style&index=0&id=34bdd140&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bdd140",
  null
  
)

export default component.exports